import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common/Poppins';
import Loader from 'src/components/Loader/Loader';

// min-height reserves the section's vertical space so swapping the loader for the (taller) loaded
// content doesn't collapse the layout and bounce everything below — matches the narrative loader (308px).
const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  max-width: 344px;
  min-height: 308px;
  margin: 0 auto;
  padding: 24px 0;
`;

const Dots = styled.div`
  width: 75px;
  height: 32px;
`;

// One fixed size shared by every wizard loading state so they never differ.
export const LoaderDots: React.FC = () => (
  <Dots>
    <Loader size="large" />
  </Dots>
);

const Text = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`;

interface FetchingStateProps {
  title: string;
  subtitle: string;
}

export const FetchingState: React.FC<FetchingStateProps> = ({ title, subtitle }) => (
  <Wrap>
    <LoaderDots />
    <Text>
      <Poppins px={16} weight={600} color="cflowerBlue">
        {title}
      </Poppins>
      <Poppins px={16} color="cflowerBlue" css="line-height: 1.7;">
        {subtitle}
      </Poppins>
    </Text>
  </Wrap>
);
